export const MuiTablePagination = () => ({
	px: 0,
	backgroundColor: "transparent",
	border: "none",
	boxShadow: "none",
	"& .MuiTablePagination-toolbar": { px: 0 },
	// Unified icon coloring with dashboard
	"& .MuiTablePagination-actions .MuiIconButton-root": {
		color: 'primary.main'
	},
	"& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled": {
		color: 'primary.main',
		opacity: 0.35
	},
	"& .MuiTablePagination-toolbar .MuiSelect-icon": {
		color: 'primary.main'
	}
})